import React from 'react'
import { Font, Canvas, Page, Image, View, Text, Document, StyleSheet } from '@react-pdf/renderer'
import { buildURL } from 'react-imgix'

import CalibreRegular from './../assets/fonts/Calibre/Calibre-Regular.ttf'
import CalibreLight from './../assets/fonts/Calibre/Calibre-Light.ttf'
import CalibreSemibold from './../assets/fonts/Calibre/Calibre-Semibold.ttf'

// Register font
Font.register({
  family: 'Calibre',
  fonts: [{ src: CalibreRegular }, { src: CalibreLight, fontWeight: 300 }, { src: CalibreSemibold, fontWeight: 600 }],
})

// Create Styles
const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Calibre',
    padding: 50,
  },
  cover: {
    position: 'absolute',
    width: '100vw',
    top: 67,
    left: 0,
    padding: 50,
  },
  title: {
    position: 'absolute',
    top: 105,
    left: 46,
    fontSize: 56,
    fontWeight: 300,
    color: '#999',
    lineHeight: 0.9,
    textTransform: 'uppercase',
    textDecoration: 'none',
  },
  logo: {
    position: 'absolute',
    width: 200,
    height: 95,
    top: 50,
    left: 50,
  },
  section: {
    width: '100%',
    paddingTop: 150,
  },
  row: {
    width: '100%',
    flexDirection: 'row',
    marginLeft: -7.5,
    marginRight: -7.5,
  },
  col: {
    width: '50%',
    paddingLeft: 7.5,
    paddingRight: 7.5,
    fontSize: 9,
  },
  col33: {
    width: '33.33%',
    marginTop: 15,
    paddingLeft: 7.5,
    paddingRight: 7.5,
    fontSize: 9,
  },
  header: {
    borderTop: '1pt solid #eee',
    paddingTop: 15,
  },
  attributes: {
    paddingTop: 25,
    paddingBottom: 15,
  },
  attributeItem: {
    width: '100%',
    flexDirection: 'row',
    paddingTop: 2.5,
    paddingBottom: 2.5,
  },
  attributeItemKey: {
    width: '40%',
    color: '#999',
  },
  attributeItemValue: {
    flexGrow: 1,
  },
  image: {
    width: '100%',
    margin: 0,
    padding: 0,
    top: 0,
  },
  footer: {
    position: 'absolute',
    fontSize: 8,
    lineHeight: 1.4,
    bottom: 0,
    left: 0,
    paddingLeft: 50,
    paddingRight: 25,
    paddingBottom: 25,
    color: '#fff',
  },
  pageBackground: {
    position: 'absolute',
    display: 'block',
    width: '100vw',
    height: '100vh',
  },
})

const logo = (Painter, availableWidth, availableHeight) => {
  Painter.path(
    'M40.7 8.7c0-4.2 3.4-7.6 7.6-7.6 4.2 0 7.6 3.4 7.6 7.6 0 4.2-3.4 7.6-7.6 7.6-4.2.1-7.6-3.3-7.6-7.6m-1.1 0c0 4.8 3.9 8.7 8.7 8.7 4.8 0 8.7-3.9 8.7-8.7C57 3.9 53.1 0 48.3 0c-4.8 0-8.7 3.9-8.7 8.7'
  )
    .path(
      'M44.8 3.3c.4 0 .5.6.5.8.1.8.2 2.5 1.3 3.6.8.8 1.7.9 3 1.1l.4.1c1.7.2 2.9 1.4 3.3 3.2v.2c.1.5.2 1-.1 1.1h-.3c-.2-.1-.3-.5-.4-.8-.7-2.1-1.4-2.2-2.8-2.4l-.5-.1c-1.8-.1-3-.5-4.1-2.1-.7-1.1-.8-2.5-.8-3.4v-.3c.1-.8.3-1 .5-1M45.1 11.1c-.2.5-.4.9-1 1.4-.1.1-.3.3-.3.5 0 .1 0 .2.1.3.2.2.4.1.7-.1 1.3-.7 1.5-1.2 1.9-2.1V11c.1-.2.1-.5 0-.6l-.3-.3c-.6-.2-.9.4-1.1 1M24.3 3.8h1.3v10h-1.3zM35.2 13.7h-1l-5.5-7.9v7.9h-1.3v-10h1.2l5.4 7.7V3.7h1.2zM15.6 4.9c2 0 3.7 1.7 3.7 3.9s-1.7 3.9-3.7 3.9-3.7-1.7-3.7-3.9 1.6-3.9 3.7-3.9m0-1.3c-2.7 0-4.9 2.3-4.9 5.1s2.2 5.1 4.9 5.1 4.9-2.3 4.9-5.1-2.2-5.1-4.9-5.1M5.4 10V8.8h4v.7c0 2.7-1.8 4.4-4.5 4.4-2.9 0-4.9-2-4.9-5.2s2.1-5.1 4.8-5.1c2.3 0 3.8 1.2 4.3 3.1H7.7c-.4-1.2-1.3-1.9-2.9-1.9-2.1 0-3.6 1.6-3.6 4s1.4 4 3.6 4c1.9 0 3-1.1 3.2-2.7H5.4zM72.4 29c1.9 0 3.7.4 5.5 1.1 1.7.7 3.2 1.8 4.5 3.1 1.3 1.3 2.3 2.9 3.1 4.7.7 1.8 1.1 3.8 1.1 5.8s-.4 3.9-1.1 5.7c-.7 1.8-1.7 3.3-3.1 4.7-1.3 1.3-2.8 2.4-4.5 3.1-1.7.8-3.6 1.1-5.5 1.1s-3.7-.4-5.5-1.1c-1.7-.7-3.2-1.8-4.5-3.1-1.3-1.4-2.3-2.9-3.1-4.7-.7-1.8-1.1-3.8-1.1-5.7 0-2 .4-3.9 1.1-5.8.7-1.8 1.7-3.3 3.1-4.7 1.3-1.3 2.8-2.4 4.5-3.1 1.7-.7 3.6-1.1 5.5-1.1m0-2.9c-9.5 0-17.1 7.9-17.1 17.7S63 61.5 72.4 61.5s17.1-7.9 17.1-17.7-7.6-17.7-17.1-17.7M3.3 46.1v15.1H.4v-35H13c6.9 0 11.1 3.4 11.1 9.9 0 6.6-4.2 10-11.1 10H3.3zm9.6-17.2H3.3v14.6H13c5.4 0 8.3-2.7 8.3-7.3-.1-4.6-2.9-7.3-8.4-7.3M31.4 45.8v15.4h-2.9v-35h12.4c6.9 0 11 3.4 11 9.8 0 5.7-3.4 8.9-8.9 9.6l10.6 15.6h-3.4L39.8 45.8h-8.4zm0-2.6h9.4c5.4 0 8.3-2.7 8.3-7.2 0-4.6-2.9-7.2-8.3-7.2h-9.4v14.4zM139.8 26.2v2.7h-18.9v13H138v2.6h-17.1v14.1h18.9v2.6H118v-35zM175.6 26.2h28.5v2.7h-12.8v32.3h-2.9V28.9h-12.8zM171.7 50.8c-.6 1.3-1.4 2.5-2.4 3.5-1.2 1.3-2.7 2.4-4.3 3.1-1.6.7-3.4 1.1-5.2 1.1s-3.5-.4-5.2-1.1c-1.6-.7-3.1-1.8-4.3-3.1-1.3-1.4-2.3-2.9-2.9-4.7-.7-1.8-1.1-3.8-1.1-5.8s.4-4 1.1-5.8c.7-1.8 1.7-3.3 2.9-4.7 1.2-1.3 2.7-2.4 4.3-3.1 1.6-.7 3.4-1.1 5.2-1.1s3.5.4 5.2 1.1c1.6.7 3.1 1.8 4.3 3.1 1 1 1.8 2.2 2.4 3.5l2.4-1.7c-2.8-5.4-8.2-9-14.3-9-9.1 0-16.4 7.9-16.4 17.7 0 9.8 7.4 17.7 16.4 17.7 6.1 0 11.5-3.6 14.3-9l-2.4-1.7zM109.5 26.2v23.9c0 6.3-3.5 8.9-8.1 8.9-4.2 0-7.1-2.5-7.9-6.5l-2.9.8c1.1 5.2 5.2 8.5 10.9 8.5 6.2 0 11-3.8 11-11.6v-24h-3z'
    )
    .fill('black')
}

const logoWhite = (Painter, availableWidth, availableHeight) => {
  Painter.path(
    'M40.7 8.7c0-4.2 3.4-7.6 7.6-7.6 4.2 0 7.6 3.4 7.6 7.6 0 4.2-3.4 7.6-7.6 7.6-4.2.1-7.6-3.3-7.6-7.6m-1.1 0c0 4.8 3.9 8.7 8.7 8.7 4.8 0 8.7-3.9 8.7-8.7C57 3.9 53.1 0 48.3 0c-4.8 0-8.7 3.9-8.7 8.7'
  )
    .path(
      'M44.8 3.3c.4 0 .5.6.5.8.1.8.2 2.5 1.3 3.6.8.8 1.7.9 3 1.1l.4.1c1.7.2 2.9 1.4 3.3 3.2v.2c.1.5.2 1-.1 1.1h-.3c-.2-.1-.3-.5-.4-.8-.7-2.1-1.4-2.2-2.8-2.4l-.5-.1c-1.8-.1-3-.5-4.1-2.1-.7-1.1-.8-2.5-.8-3.4v-.3c.1-.8.3-1 .5-1M45.1 11.1c-.2.5-.4.9-1 1.4-.1.1-.3.3-.3.5 0 .1 0 .2.1.3.2.2.4.1.7-.1 1.3-.7 1.5-1.2 1.9-2.1V11c.1-.2.1-.5 0-.6l-.3-.3c-.6-.2-.9.4-1.1 1M24.3 3.8h1.3v10h-1.3zM35.2 13.7h-1l-5.5-7.9v7.9h-1.3v-10h1.2l5.4 7.7V3.7h1.2zM15.6 4.9c2 0 3.7 1.7 3.7 3.9s-1.7 3.9-3.7 3.9-3.7-1.7-3.7-3.9 1.6-3.9 3.7-3.9m0-1.3c-2.7 0-4.9 2.3-4.9 5.1s2.2 5.1 4.9 5.1 4.9-2.3 4.9-5.1-2.2-5.1-4.9-5.1M5.4 10V8.8h4v.7c0 2.7-1.8 4.4-4.5 4.4-2.9 0-4.9-2-4.9-5.2s2.1-5.1 4.8-5.1c2.3 0 3.8 1.2 4.3 3.1H7.7c-.4-1.2-1.3-1.9-2.9-1.9-2.1 0-3.6 1.6-3.6 4s1.4 4 3.6 4c1.9 0 3-1.1 3.2-2.7H5.4zM72.4 29c1.9 0 3.7.4 5.5 1.1 1.7.7 3.2 1.8 4.5 3.1 1.3 1.3 2.3 2.9 3.1 4.7.7 1.8 1.1 3.8 1.1 5.8s-.4 3.9-1.1 5.7c-.7 1.8-1.7 3.3-3.1 4.7-1.3 1.3-2.8 2.4-4.5 3.1-1.7.8-3.6 1.1-5.5 1.1s-3.7-.4-5.5-1.1c-1.7-.7-3.2-1.8-4.5-3.1-1.3-1.4-2.3-2.9-3.1-4.7-.7-1.8-1.1-3.8-1.1-5.7 0-2 .4-3.9 1.1-5.8.7-1.8 1.7-3.3 3.1-4.7 1.3-1.3 2.8-2.4 4.5-3.1 1.7-.7 3.6-1.1 5.5-1.1m0-2.9c-9.5 0-17.1 7.9-17.1 17.7S63 61.5 72.4 61.5s17.1-7.9 17.1-17.7-7.6-17.7-17.1-17.7M3.3 46.1v15.1H.4v-35H13c6.9 0 11.1 3.4 11.1 9.9 0 6.6-4.2 10-11.1 10H3.3zm9.6-17.2H3.3v14.6H13c5.4 0 8.3-2.7 8.3-7.3-.1-4.6-2.9-7.3-8.4-7.3M31.4 45.8v15.4h-2.9v-35h12.4c6.9 0 11 3.4 11 9.8 0 5.7-3.4 8.9-8.9 9.6l10.6 15.6h-3.4L39.8 45.8h-8.4zm0-2.6h9.4c5.4 0 8.3-2.7 8.3-7.2 0-4.6-2.9-7.2-8.3-7.2h-9.4v14.4zM139.8 26.2v2.7h-18.9v13H138v2.6h-17.1v14.1h18.9v2.6H118v-35zM175.6 26.2h28.5v2.7h-12.8v32.3h-2.9V28.9h-12.8zM171.7 50.8c-.6 1.3-1.4 2.5-2.4 3.5-1.2 1.3-2.7 2.4-4.3 3.1-1.6.7-3.4 1.1-5.2 1.1s-3.5-.4-5.2-1.1c-1.6-.7-3.1-1.8-4.3-3.1-1.3-1.4-2.3-2.9-2.9-4.7-.7-1.8-1.1-3.8-1.1-5.8s.4-4 1.1-5.8c.7-1.8 1.7-3.3 2.9-4.7 1.2-1.3 2.7-2.4 4.3-3.1 1.6-.7 3.4-1.1 5.2-1.1s3.5.4 5.2 1.1c1.6.7 3.1 1.8 4.3 3.1 1 1 1.8 2.2 2.4 3.5l2.4-1.7c-2.8-5.4-8.2-9-14.3-9-9.1 0-16.4 7.9-16.4 17.7 0 9.8 7.4 17.7 16.4 17.7 6.1 0 11.5-3.6 14.3-9l-2.4-1.7zM109.5 26.2v23.9c0 6.3-3.5 8.9-8.1 8.9-4.2 0-7.1-2.5-7.9-6.5l-2.9.8c1.1 5.2 5.2 8.5 10.9 8.5 6.2 0 11-3.8 11-11.6v-24h-3z'
    )
    .fill('white')
}

const GroupPage = ({ group }) => (
  <Page size="A4" style={{ ...styles.page, backgroundColor: '#111111' }}>
    <Canvas style={styles.logo} paint={logoWhite}></Canvas>
    <Text style={styles.title}>{group.displayTitle}</Text>
  </Page>
)

const ProductPage = ({ product }) => (
  <Page size="A4" style={styles.page}>
    <Canvas style={styles.logo} paint={logo}></Canvas>
    <Text style={styles.title}>{product.family.title}</Text>
    <View style={styles.section}>
      <View style={styles.row}>
        <View style={styles.col}>
          <Image
            style={styles.image}
            src={buildURL(process.env.REACT_APP_IMAGE_URL + product.images.product[0].src, {
              auto: 'compress,enhance',
              blend: '#EEEEEE',
              blendMode: 'multiply',
              bri: 3,
              dpr: 2,
              w: 800,
              h: 1120,
              fit: 'clamp',
              fm: 'jpg',
              rect: product.images.product[0].rect,
            })}
          />
        </View>
        <View style={styles.col}>
          <View style={styles.header}>
            <Text style={{ fontSize: 24, fontWeight: 300, lineHeight: 0.9, textTransform: 'uppercase' }}>
              {product.family.title}
            </Text>
            <Text style={{ fontSize: 24, fontWeight: 300, lineHeight: 0.9, color: '#999', textTransform: 'uppercase' }}>
              {product.group.title}
            </Text>
          </View>
          <View style={styles.attributes}>
            <View style={styles.attributeItem}>
              <Text style={styles.attributeItemKey}>Artikelnummer</Text>
              <Text style={styles.attributeItemValue}>{product.sku}</Text>
            </View>
            {product.materials.base && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Material Gestell</Text>
                <Text style={styles.attributeItemValue}>{product.materials.base.title}</Text>
              </View>
            )}
            {product.materials.seating && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Material Sitz</Text>
                <Text style={styles.attributeItemValue}>{product.materials.seating.title}</Text>
              </View>
            )}
            {product.materials.tabletop && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Material Tischplatte</Text>
                <Text style={styles.attributeItemValue}>{product.materials.tabletop.title}</Text>
              </View>
            )}
            <View style={styles.attributeItem}>
              <Text style={styles.attributeItemKey}>Maße</Text>
              <Text
                style={styles.attributeItemValue}
              >{`${product.attributes.width} x ${product.attributes.height} x ${product.attributes.depth} cm`}</Text>
            </View>
            {product.attributes.seat_height && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Sitzhöhe</Text>
                <Text style={styles.attributeItemValue}>{`${product.attributes.seat_height} cm`}</Text>
              </View>
            )}
            {product.attributes.seat_deapth && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Sitztiefe</Text>
                <Text style={styles.attributeItemValue}>{`${product.attributes.seat_deapth} cm`}</Text>
              </View>
            )}
            {product.attributes.armrest_height && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Armlehnenhöhe</Text>
                <Text style={styles.attributeItemValue}>{`${product.attributes.armrest_height} cm`}</Text>
              </View>
            )}
            {product.attributes.weight && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Gewicht</Text>
                <Text style={styles.attributeItemValue}>{`${product.attributes.weight} kg`}</Text>
              </View>
            )}
            {product.attributes.application_area && (
              <View style={styles.attributeItem}>
                <Text style={styles.attributeItemKey}>Einsatzbereich</Text>
                <Text style={styles.attributeItemValue}>{product.attributes.application_area}</Text>
              </View>
            )}
          </View>
        </View>
      </View>
      <View style={styles.row}>
        {product.images.product[1] && (
          <View style={styles.col33}>
            <Image
              style={styles.image}
              src={buildURL(process.env.REACT_APP_IMAGE_URL + product.images.product[1].src, {
                auto: 'compress,enhance',
                blend: '#EEEEEE',
                blendMode: 'multiply',
                bri: 3,
                dpr: 2,
                w: 800,
                h: 1120,
                fit: 'clamp',
                fm: 'jpg',
                rect: product.images.product[1].rect,
              })}
            />
          </View>
        )}
        {product.images.product[2] && (
          <View style={styles.col33}>
            <Image
              style={styles.image}
              src={buildURL(process.env.REACT_APP_IMAGE_URL + product.images.product[2].src, {
                auto: 'compress,enhance',
                blend: '#EEEEEE',
                blendMode: 'multiply',
                bri: 3,
                dpr: 2,
                w: 800,
                h: 1120,
                fit: 'clamp',
                fm: 'jpg',
                rect: product.images.product[2].rect,
              })}
            />
          </View>
        )}
        {product.images.product[3] && (
          <View style={styles.col33}>
            <Image
              style={styles.image}
              src={buildURL(process.env.REACT_APP_IMAGE_URL + product.images.product[3].src, {
                auto: 'compress,enhance',
                blend: '#EEEEEE',
                blendMode: 'multiply',
                bri: 3,
                dpr: 2,
                w: 800,
                h: 1120,
                fit: 'clamp',
                fm: 'jpg',
                rect: product.images.product[3].rect,
              })}
            />
          </View>
        )}
      </View>
    </View>
    <Text style={styles.footer} fixed render={({ pageNumber }) => `GO IN PROJECT — ${pageNumber - 1}`} />
  </Page>
)

const CatalogueTemplate = (props) => (
  <Document title="GO IN Project — Catalogue" author="GO IN GmbH">
    <Page size="A4" style={{ ...styles.page, backgroundColor: '#212121' }}>
      <Image
        src="https://goin-project.com/images/demo/menu/hocker.jpg?auto=compress%2C%20enhance&f=jpg&&fit=crop&ar=1:1.4142&w=2048&bri=-30"
        style={styles.pageBackground}
      />
      <Canvas style={styles.logo} paint={logoWhite}></Canvas>
      <Text style={styles.title}>Katalog</Text>
      <Text style={styles.footer} fixed>
        {`GO IN PROJECT · GO IN GmbH · Justus-von-Liebig-Straße 3-5 · 86899 Landsberg am Lech · Deutschland
        T +49 81 9191 94 – 230 · F +49 81 91 91 94 – 199 · info@goin-project.com · goin-project.com · HRB 17630 Augsburg
        USt-ID-Nummer: DE 129 360 871 · Geschäftsführer: Nicolai Reisenthel · Maurus Reisenthel`}
      </Text>
    </Page>
    {props.data.map((group, index) => {
      return (
        <React.Fragment key={index}>
          <GroupPage group={group}></GroupPage>
          {group.products.map((product) => {
            return <ProductPage product={product} key={product.sku}></ProductPage>
          })}
        </React.Fragment>
      )
    })}
  </Document>
)

export default CatalogueTemplate
